import { service } from '../axios';
// 获取耗材分类树
export function getConsCategoryTree() {
    return service({
        url: '/cons/cons-category/tree',
        method: 'get',
    });
}
// 新增耗材分类
export function createConsCategory(data) {
    return service({
        url: '/cons/cons-category/create',
        method: 'post',
        data,
    });
}
// 更新耗材分类
export function updateConsCategory(data) {
    return service({
        url: '/cons/cons-category/update',
        method: 'post',
        data,
    });
}
// 删除耗材分类
export function deleteConsCategory(categoryId) {
    return service({
        url: `/cons/cons-category/delete/${categoryId}`,
        method: 'delete',
    });
}
export function pageConsByCategory(params) {
    return service({
        url: '/cons/pageCons',
        method: 'get',
        params
    });
}
export async function getConsStockData(data) {
    return service({
        url: '/cons/report/getStockData',
        method: 'post',
        data
    });
}
export async function getConsConsumeData(data) {
    return service({
        url: '/cons/report/getConsumeData',
        method: 'post',
        data
    });
}
export async function getConsConsumeTrendData(data) {
    return service({
        url: '/cons/report/getConsumeTrendData',
        method: 'post',
        data
    });
}
